<template>
  <div
    style="width: 100%"
    class="ml-2"
  >
    <v-col
      v-for="f in filtro"
      :key="f.titulo"
      cols="12"
    >
      <filtro-base :value="f" />
    </v-col>
  </div>
</template>

<script>
import FiltroBase from '@/components/monitoramento/perfil/filtro/base/FiltroBase';
import FiltroPerfil from '@/modules/filtroPerfil';

export default {
  name: 'FiltroFormacaoComplementar',

  components: { FiltroBase },

  data() {
    return {
      filtro: {
        formacao: {
          titulo: 'FORMAÇÃO COMPLEMENTAR',
          habilitado: true,
          filhos: [
            {
              id: 'idiomas',
              tipo: 'select',
              titulo: 'Idiomas',
              habilitado: false,
              selecionado: [],
              lista: this.$store.state.perfil.idiomas.filter((c) => !c.isOutro),
              itemText: 'nome',
              icone: 'local_library',
              multiplo: true,
              colunas: 12,
              filhos: [
                {
                  id: 'outros',
                  tipo: 'extra',
                  titulo: 'Pesquisar Outro(s)',
                  opcao: false,
                  outros: null,
                },
              ],
            },
            {
              id: 'areasCapacitacao',
              tipo: 'select',
              titulo: 'Áreas de Capacitação',
              habilitado: false,
              selecionado: [],
              lista: this.$store.state.perfil.listaAreasProfissional.filter((c) => c.id),
              itemText: 'nome',
              icone: 'emoji_objects',
              multiplo: true,
              todas: true,
              colunas: 12,
              filhos: [],
            },
            {
              id: 'instrutorCapacitacao',
              tipo: 'confirm',
              titulo: 'Instrutor de Capacitação?',
              habilitado: false,
              opcoes: [
                { nome: 'Sim', valor: true },
                { nome: 'Não', valor: false },
              ],
              opcao: null,
              horizontal: true,
              colunas: 12,
              filhosDependentes: true,
              filhos: [
                {
                  id: 'outros',
                  tipo: 'extra',
                  titulo: 'Pesquisar Curso(s)',
                  opcao: false,
                  outros: null,
                },
              ],
            },
          ],
        },
      },
    };
  },

  watch: {
    filtro: {
      handler(value) {
        const filtroIdiomas = FiltroPerfil.get('idiomas', value.formacao.filhos);
        const filtroIdiomasOutros = FiltroPerfil.get('outros', filtroIdiomas.filhos);
        const filtroAreasCapacitacao = FiltroPerfil.get('areasCapacitacao', value.formacao.filhos);
        const filtroInstrutorCapacitacao = FiltroPerfil.get('instrutorCapacitacao', value.formacao.filhos);
        const filtroInstrutorCapacitacaoOutros = FiltroPerfil.get('outros', filtroInstrutorCapacitacao.filhos);

        const retorno = {
          idiomas: {
            ...FiltroPerfil.getRetorno(filtroIdiomas),
            outros: FiltroPerfil.getRetorno(filtroIdiomasOutros),
          },
          areasCapacitacao: FiltroPerfil.getRetorno(filtroAreasCapacitacao),
          instrutorCapacitacao: {
            ...FiltroPerfil.getRetorno(filtroInstrutorCapacitacao),
            outros: FiltroPerfil.getRetorno(filtroInstrutorCapacitacaoOutros),
          },
        };
        retorno.habilitado = FiltroPerfil.getHabilitado(retorno);
        this.$emit('return', retorno.habilitado ? retorno : null);
      },
      deep: true,
    },
  },
};
</script>
